import EnableMfa from 'src/features/auth/components/EnableMfa';

export default function EnableMfaPage() {
  return <EnableMfa redirectUrl="/plugins/outlook/login" dashboardUrl="/plugins/outlook/taskpane" className="w-full" />;
}
